import request from '@/utils/request';
import {
  setStore,
  getStore,
} from '@/utils/store'
const projectName = '/api/blade-platform';

const serviceMonitoring = {
    state: {
        serviceOverviewComponentName: getStore({ name: 'serviceOverviewComponentName' }) || 'basicPage',
        serviceScoreComponentName: getStore({ name: 'serviceScoreComponentName' }) || 'basicPage',
        serviceAccessRecordComponentName: getStore({ name: 'serviceAccessRecordComponentName' }) || 'basicPage',
        serviceCollectionStatisticsComponentName: getStore({ name: 'serviceCollectionStatisticsComponentName' }) || 'basicPage',
        visitCountComponentName: getStore({ name: 'visitCountComponentName' }) || 'basicPage',
        visitLogComponentName: getStore({ name: 'visitLogComponentName' }) || 'basicPage',
    },
    mutations: {
        SET_serviceOverviewComponentName: (state, serviceOverviewComponentName) => {
            state.serviceOverviewComponentName = serviceOverviewComponentName
            setStore({
                name: 'serviceOverviewComponentName',
                content: state.serviceOverviewComponentName,
                type: 'session'
            })
        },
        SET_serviceAccessRecordComponentName: (state, serviceAccessRecordComponentName) => {
            state.serviceAccessRecordComponentName = serviceAccessRecordComponentName
            setStore({
                name: 'serviceAccessRecordComponentName',
                content: state.serviceAccessRecordComponentName,
                type: 'session'
            })
        },
        SET_serviceCollectionStatisticsComponentName: (state, serviceCollectionStatisticsComponentName) => {
            state.serviceCollectionStatisticsComponentName = serviceCollectionStatisticsComponentName
            setStore({
                name: 'serviceCollectionStatisticsComponentName',
                content: state.serviceCollectionStatisticsComponentName,
                type: 'session'
            })
        },
        SET_serviceScoreComponentName: (state, serviceScoreComponentName) => {
            state.serviceScoreComponentName = serviceScoreComponentName
            setStore({
                name: 'serviceScoreComponentName',
                content: state.serviceScoreComponentName,
                type: 'session'
            })
        },
        SET_visitCountComponentName: (state, visitCountComponentName) => {
            state.visitCountComponentName = visitCountComponentName
            setStore({
                name: 'visitCountComponentName',
                content: state.visitCountComponentName,
                type: 'session'
            })
        },
        SET_visitLogComponentName: (state, visitLogComponentName) => {
            state.visitLogComponentName = visitLogComponentName
            setStore({
                name: 'visitLogComponentName',
                content: state.visitLogComponentName,
                type: 'session'
            })
        }
    },
    actions: {
        // 获取评分机制
        scoreMechanismDetail(actions) {
            return request({
                url: `${projectName}/scoreMechanism/detail`,
                method: 'get',
            })
        },
        // 查看服务评价统计
        serviceScoreCountList(actions, data) {
            return request({
                url: `${projectName}/serviceScore/list`,
                method: 'post',
                data
            })
        },
        // 获取服务评分详细列表
        serviceScoreList(actions, data) {
            return request({
                url: `${projectName}/serviceScore/serviceScoreList`,
                method: 'post',
                data
            })
        },
        // 保存评分机制
        updateScoreMechanism(actions, data) {
            return request({
                url: `${projectName}/scoreMechanism/update`,
                method: 'post',
                data
            })
        },
        // 服务访问统计列表
        visitCountList(actions, data) {
            return request({
                url: `${projectName}/visitLog/list`,
                method: 'post',
                data
            })
        },
        // 服务访问日志列表
        visitLogList(actions, data) {
            return request({
                url: `${projectName}/visitLog/findServiceList`,
                method: 'post',
                data
            })
        },
        // 服务收藏统计
        findServiceCountList(actions, data) {
            return request({
                url: `${projectName}/userService/findServiceCountList`,
                method: 'post',
                data
            })
        },
        // 服务概览
        getServicePreview(actions, data) {
            return request({
                url: `${projectName}/visitLog/getServicePreview`,
                method: 'post',
                data
            })
        },
        // 获取服务访问top 10
        getServiceByTop(actions, data) {
            return request({
                url: `${projectName}/visitLog/getServiceByTop`,
                method: 'post',
                data
            })
        },
    }
}
export default serviceMonitoring
